<h2 matDialogTitle>@if(isEdit){Edit} @else {Add} Vehicle Hardware@if(selectedHardware) { - {{ vehicleHardwareTypeLabels[selectedHardware] }} }</h2>

<form [formGroup]="formGroup">
	<div mat-dialog-content>
		@if (isLoading) {
			<mat-spinner mode="indeterminate" diameter="30" class="mx-a"></mat-spinner>
		} @else {
			@if (!selectedHardware) {
				<h3>Choose what hardware type you'd like to add</h3>
				<div class="flex-column">
					@for (type of hardwareTypeToAdd; track type) {
						<button mat-stroked-button
								(click)="selectedAddedHardwareType(type)">
							{{ vehicleHardwareTypeLabels[type] }}
						</button>
					}
				</div>
			} @else {
				@switch (selectedHardware) {
					@case (VehicleHardwareChoice.CAMERA) {
						<app-camera-configuration formControlName="cameraConfiguration">
						</app-camera-configuration>
					}
					@case (VehicleHardwareChoice.DIGITAL_SPREADER) {
						<app-digital-spreader-configuration formControlName="digitalSpreader">
						</app-digital-spreader-configuration>
					}
					@case (VehicleHardwareChoice.PLOW) {
						<app-plow-configuration formControlName="plow"
												[availableInputs]="getAvailableInputs()">
						</app-plow-configuration>
					}
					@case (VehicleHardwareChoice.SPREADER) {
						<app-spreader-configuration formControlName="spreader"
													[availableInputs]="getAvailableInputs()">
						</app-spreader-configuration>
					}
					@default {
					 	<app-input-connection-configuration formControlName="genericDevice"
											   [availableInputs]="getAvailableInputs()">
						</app-input-connection-configuration>
					}
				}
			}

			@if (saveError) {
				<mat-error>{{ saveError }}</mat-error>
			}
		}
		@if (isSaving) {
			<mat-progress-bar mode="indeterminate"></mat-progress-bar>
		}
	</div>

	<div mat-dialog-actions class="gap-4 flex-row">
		<button mat-stroked-button
				matDialogClose>
			Cancel
		</button>

		<button mat-flat-button
				type="submit"
				[disabled]="!selectedHardware || formGroup.invalid || formGroup.pending || isSaving"
				(click)="updateVehicleHardware()">
			@if (isEdit) {
				Save
			} @else {
				Add
			}
		</button>
	</div>
</form>
